module.exports = __webpack_public_path__ + "static/scale-model-of-gertie-the-duck---symbol-of-hope-in-milwaukee-wisconsin-16c6d158b05a995495f43d851c409648.png";